module.exports = __webpack_public_path__ + "img/Yoshitaya_en.9c2a7dfb.jpg";